// ======================================================================
// File Name       : ScoringReportTabMenuContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { saveReportActiveTabMenu } from '../../../actions/TabMenuReportAction';
import * as Path from '../../../constants/PathConstants';
import ScoringReportContainer from './ScoringReportContainer';
import * as ReportConstants from '../../../constants/ScoringReportConstants';
import * as AuthorityConstant from '../../../constants/AuthorityConstant';

class ScoringReportTabMenuContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      headerTitle: '',
      titleList: [],
      componentList: [],
    };
    this.handleSelectTab = this.handleSelectTab.bind(this);
  }

  componentWillMount() {
    const {match, authedUser} = this.props;
    const { scoringManagementAuthority } = authedUser.managementFunctionAuthorityInfo;
    if(scoringManagementAuthority == AuthorityConstant.SCORING_MANAGEMENT_AUTHORITY_TYPE.SCORING_APPROVAL) {
      this.setState({
        headerTitle: '',
        eventKeyList: [
          Path.SCORING_REPORT_TOP, Path.SCORING_REPORT_GET,
          Path.SCORING_REPORT_CORRECTION, Path.SCORING_REPORT_APPROVAL,
          Path.SCORING_REPORT_REMAND, Path.SCORING_REPORT_COLLECTION,
        ],
        titleList: ['一覧', '取得', '添削', '承認', '差し戻し', '強制回収'],
        componentList: [
          <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.TOP} />, <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.GET} />,
          <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.CORRECTION} />, <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.APPROVAL} />,
          <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.REMAND} />, <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.COMPULSORY_COLLECTION} />,
        ],
      });
    } else {
      this.setState({
        headerTitle: '',
        eventKeyList: [
          Path.SCORING_REPORT_TOP, Path.SCORING_REPORT_GET,
          Path.SCORING_REPORT_CORRECTION, Path.SCORING_REPORT_WITHDRAWAL,
        ],
        titleList: ['一覧', '取得', '添削', '取り下げ'],
        componentList: [
          <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.TOP} />, <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.GET} />,
          <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.CORRECTION} />, <ScoringReportContainer match={match} mode={ReportConstants.REPORT_LIST_MODE.WITHDRAWAL} />,
        ],
      });
    }
  }

  handleSelectTab(key) {
    const { dispatch, history } = this.props.props ? this.props.props : this.props;
    history.replace({
      pathname: `${key}`,
    });
    dispatch(saveReportActiveTabMenu(key));
  }

  render() {
    const { headerTitle, eventKeyList, titleList, componentList } = this.state;
    const { activeReportTab, history, url } = this.props;
    let defaultActiveKey = '';
    if (activeReportTab && eventKeyList.indexOf(activeReportTab) > -1) {
      defaultActiveKey = activeReportTab;
    } else {
      defaultActiveKey = eventKeyList[0];
    }
    const content = [];
    for (const i in eventKeyList) {
      const eventKey = eventKeyList[i];
      content.push(
        <Tab
          key={eventKey}
          eventKey={eventKey}
          title={
            <div className='inline-flex'>
              {titleList[i]}
            </div>
          }
        >
          {eventKey === defaultActiveKey && (
            componentList[i]
          )}
        </Tab>,
      );
    }
    return (
      <>
        <Col sm={2} className="bold padding-10 padding-right-clear">
          <div>ステータス別絞り込み</div>
        </Col>
          <Tabs id="sub-tab-container" defaultActiveKey={defaultActiveKey} onSelect={this.handleSelectTab}>
            {content}
          </Tabs>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { activeReportTab } = state.tabMenu;
  return {
    activeReportTab,
  };
};

export default connect(mapStateToProps)(ScoringReportTabMenuContainer);